<template>
  <section>
    <div
      id="myChart"
      ref="myChart"
      :style="{ height: boxHeight + 'rem' }"
    ></div>
  </section>
</template>

<script>
const colorList = ["#4992FF", "#58D9F9", "#7CFFB2"];

import * as echarts from "echarts";
export default {
  data() {
    return {
      myChart: null,
      dataValue: [],
      yName: [],
      mountData: "",
      updateData: "",
      fullDiv: {
        top: "25%",
      },
    };
  },
  props: {
    boxHeight: {
      default: 21,
      type: Number,
    },
    showtime: {
      default: false,
      type: Boolean,
    },
    showLegend: {
      default: false,
      type: Boolean,
    },
    coordinateName: {
      default: "",
      type: String,
    },
    graphicalRightData: {
      //是否显示图形右边的文字
      default: false,
      type: Boolean,
    },
  },

  components: {},

  mounted() {
    let that = this;
    if (window.outerWidth <= 1920) {
      this.fullDiv = {
        left: "0",
        right: "5%",
        bottom: "1%",
        top: "30%",
        containLabel: true,
      };
    }
    window.onresize = function () {
      that.myChart.resize();
    };
  },
  watch: {},
  methods: {
    upDateChart(content) {
      this.myChart.setOption({
        series: [{ data: content.data }],
        yAxis: [
          // {
          //   data: (() => {
          //     if (this.graphicalRightData) {
          //       let list = [];
          //       content.yName.map((y, y_index) => {
          //         list.push(y_index + 1);
          //       });
          //       return list;
          //     } else {
          //       return content.yName;
          //     }
          //   })(),
          // },
          {
            data: content.data,
          },
        ],
      });
    },
    myEcharts(data) {
      let echarts = require("echarts");
      // 基于准备好的dom，初始化echarts实例
      this.myChart = echarts.init(this.$refs.myChart);
      this.setChartData(data);
      // 指定图表的配置项和数据
    },
    setChartData(data) {
      // console.log("data", data);
      let option = {
        xAxis: {
          name: "",
          nameLocation: "end",
          splitLine: {
            color: "#CCCCCC",
            show: false,
          },
          axisLabel: {
            fontSize: this.$common.setFontSize(0.77),
          },
          axisLine: {
            show: true,
            lineStyle: {
              color: "#fff",
            },
          },
          data: data.xData,
        },
        yAxis: data.yData,
        dataZoom: [
          {
            type: "inside",
          },
          {
            show: false,
            yAxisIndex: 0,
            filterMode: "empty",
            width: 30,
            height: "80%",
            showDataShadow: false,
            left: "93%",
          },
        ],
        series:
          // data.dataList,
          (() => {
            let list = [];
            data.dataList.map((li, l_index) => {
              let item = {
                name: li.name,
                type: li.type,
                data: li.data,
                label: li.label ? li.label : "",
                barWidth: 5,
                smooth: false,
                markLine: li.markLine ? li.markLine : null,
                lineStyle: {
                  color: li.lineColor ? li.lineColor : null,
                },
                itemStyle: {
                  color: li.itemColor ? li.itemColor : li.lineColor,
                },
                symbol: li.symbol,
                yAxisIndex: li.yAxisIndex ? li.yAxisIndex : 0,
              };
              list.push(item);
            });
            return list;
          })(),
        // [
        //   {
        //     // name: "X",
        //     type: "bar",
        //     barWidth: 5,
        //     data: data.dataList[0].data, //dataArr,
        //     label: data.dataList[1].label,
        //     // itemStyle: {
        //     //   emphasis: {
        //     //     barBorderRadius: 7,
        //     //   },
        //     //   normal: {
        //     //     barBorderRadius: 7,
        //     //     color: new echarts.graphic.LinearGradient(0, 0, 1, 0, [
        //     //       { offset: 0, color: "#665147" },
        //     //       { offset: 1, color: "#FAC4AA00" },
        //     //     ]),
        //     //   },
        //     // },
        //     // itemStyle: {
        //     //   color: function (param) {
        //     //     // console.log("param", param);
        //     //     return colorList[param.dataIndex % 3];
        //     //   },
        //     // },
        //     // label: {
        //     //   show: true,
        //     //   position: "top",
        //     //   valueAnimation: true,
        //     //   color: "#FFFFFF",
        //     //   formatter: function (params) {
        //     //     // console.log("params", params, params.dataIndex % 2);
        //     //     if (params.dataIndex % 2 == 0) {
        //     //       return "{title|" + params.data + "}";
        //     //     } else {
        //     //       return "";
        //     //     }
        //     //     // return (params.data = data.yName[params.dataIndex]);
        //     //   },
        //     //   rich: {
        //     //     title: {
        //     //       color: "red",
        //     //       align: "center",
        //     //     },
        //     //   },
        //     // },
        //   },
        //   {
        //     // name: "X",
        //     type: "line",
        //     barWidth: 5,
        //     data: data.dataList[1].data, //dataArr,
        //     smooth: false,
        //     // symbolOffset: [10, 0],
        //     itemStyle: {
        //       normal: {
        //         color: "#84F5DE", //改变折线点的颜色
        //         lineStyle: {
        //           color: new echarts.graphic.LinearGradient(0, 0, 0, 1, [
        //             { offset: 0, color: "#188df0" },
        //             { offset: 1, color: "#83bff6" },
        //           ]),
        //         },
        //       },
        //     },
        //   },
        // ],
        legend: {
          textStyle: {
            color: "#FFF",
            fontSize: this.$common.setFontSize(0.92),
          },
          x: "center",
          top: "5%",
          data: (() => {
            let list = [];
            data.dataList.map((li, l_index) => {
              let item = {
                name: li.name,
              };
              list.push(item);
            });
            return list;
          })(),
        },
        tooltip: data.tooltipData,
        grid: this.fullDiv,
        animationDuration: 0,
        animationDurationUpdate: 3000,
        animationEasing: "linear",
        animationEasingUpdate: "linear",
      };

      // 使用刚指定的配置项和数据显示图表。
      this.myChart.setOption(option);
    },
  },
  destroyed() {},
};
</script>
<style lang='scss' scoped>
</style>